"use client";

import Link from "next/link";
import Image from "next/image";
import { FileText, Phone } from "lucide-react";
import { Button, ButtonVariantTypes } from "components/ui/button";
import { CloseButton, Description, Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
interface GetStartedProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function GetStarted({ open, onOpenChange }: GetStartedProps) {
  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      transition
      className="fixed inset-0 z-[100] flex w-screen items-center justify-center bg-transparent p-4 transition duration-300 ease-out data-[closed]:opacity-0"
    >
      <DialogPanel className="h-full overflow-y-scroll bg-neutral-0 pb-12 sm:rounded-2xl lg:h-auto lg:max-w-[950px] lg:overflow-hidden lg:pb-0">
        <div className="flex h-16 items-center justify-between border-b-[1px] border-gray-900/10 px-4 py-6 md:px-12">
          <DialogTitle className="text-left text-4xlt leading-none ">Welcome...</DialogTitle>
          <CloseButton onClick={() => onOpenChange(false)} />
        </div>
        <Description className="px-4 py-2 font-heading text-3xl md:px-12 md:text-4xl lg:py-8">
          How would you like to get started?
        </Description>
        <div className="grid grid-cols-2 gap-4 p-3  md:p-12 md:pt-4 lg:gap-8">
          <div className="col-span-2 grid items-center rounded-xl bg-[#fffdf6]  p-5 ring-1 ring-gray-200 md:col-span-1">
            <div className="flex flex-row  gap-3 md:flex-col">
              <div className="relative mb-4 h-40 min-w-[140px] overflow-hidden rounded-lg md:h-44 md:w-full">
                <Image
                  src="/starting_estimate.jpg"
                  fill
                  style={{
                    objectFit: "cover"
                  }}
                  alt="starting estimate renovation"
                />
              </div>
              <div className="block">
                <p className="mb-2 block text-lg font-medium">Get a starting estimate</p>
                <p className="mb-6 block text-sm">
                  Answer a few brief questions to get started on an estimate for your project.{" "}
                </p>
              </div>
            </div>
            <Button asChild size="xl" variant={ButtonVariantTypes.BRAND} onClick={() => onOpenChange(false)}>
              <Link href="#">
                <FileText className="mr-2" size={18} strokeWidth={2} /> Get Your Estimate
              </Link>
            </Button>
          </div>
          <div className="col-span-2 grid items-center rounded-xl bg-[#fffdf6]  p-5 ring-1 ring-gray-200 md:col-span-1">
            <div className="flex flex-row  gap-3 md:flex-col">
              <div className="relative mb-4 h-40 min-w-[140px] overflow-hidden rounded-lg md:h-44 md:w-full">
                <Image
                  src="/call.jpg"
                  fill
                  style={{
                    objectFit: "cover"
                  }}
                  alt="starting estimate renovation"
                />
              </div>
              <div className="block">
                <p className="mb-2 text-lg font-medium">Schedule a call</p>
                <p className="mb-6 text-sm">
                  Book a complimentary consultation with a Sold Ave renovation consultant to discuss your remodel goals.
                </p>
              </div>
            </div>
            <Button asChild size="xl" variant={ButtonVariantTypes.BRAND} onClick={() => onOpenChange(false)}>
              <Link href="/schedule-design-consultation">
                <Phone className="mr-2" size={18} strokeWidth={2} /> Schedule a call
              </Link>
            </Button>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
}
